import { render, staticRenderFns } from "./NeracaDetail.vue?vue&type=template&id=52d3d7e4&scoped=true"
import script from "./NeracaDetail.vue?vue&type=script&lang=js"
export * from "./NeracaDetail.vue?vue&type=script&lang=js"
import style0 from "./NeracaDetail.vue?vue&type=style&index=0&id=52d3d7e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d3d7e4",
  null
  
)

export default component.exports